import { AppTruncateDirective } from "./truncate";
import { App } from "vue";
import { AppBlurContent } from "./blur";

export const RegisterGlobalDirectices = (app: App): void => {
  app.directive("truncate", AppTruncateDirective);
  app.directive("blur", AppBlurContent);
};
